import BottomNav from 'app/RuangGTKHomepageV3/components/BottomNav'
import NavigationBar from 'app/Homepage/components/NavigationBar'
import Header from 'app/Homepage/components/Header'
import InfoTerkiniListGroup from './InfoTerkiniListGroup'
import { useMediaQueryHelper } from 'app/RuangGTKHomepageV3/hooks/useMediaQueryHelper'

const InfoTerkini = ({ isRuangGtkEnabled, isRuangGtkV3Enabled }) => {
  const { isDesktop } = useMediaQueryHelper()
  return (
    <div className="mt-14">
      <Header
        isRuangGtkEnabled={isRuangGtkEnabled}
        title={isRuangGtkEnabled ? 'Pemberitahuan' : 'Info Terkini'}
        showUserProfile={false}
      />

      <InfoTerkiniListGroup />

      {isRuangGtkV3Enabled && !isDesktop ? (
        <BottomNav />
      ) : (
        <NavigationBar isRuangGtkEnabled={isRuangGtkEnabled} />
      )}
    </div>
  )
}

export default InfoTerkini
